function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import DashboardLayout from '../layouts/DashboardLayout';
import useIntlMemo from '@/hooks/useIntlMemo';
import { FormattedMessage, useIntl } from 'react-intl';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Button, Title, TextInput, NumberInput, Text, Textarea } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { ExternalUrls, WebRoutes } from '@/utils/constants';
import useChannelStore from '@/stores/ChannelStore';
import { useNavigate, useParams } from 'react-router';
import { createTimer, getTimer, updateTimer } from '@/actions/TimerActions';
import useTimerStore from '@/stores/TimerStore';
import { CronExpressionParser } from 'cron-parser';
import { Helmet } from 'react-helmet';
import useCustomCommandStore from '@/stores/CustomCommandStore';
import useDefaultCommandStore from '@/stores/DefaultCommandStore';
import { getCustomCommands, getDefaultCommands } from '@/actions/CommandActions';
import useBackButton from '@/hooks/useBackButton';
import BackButton from '../BackButton';
import useDebouncedCallbackOnChange from '@/hooks/useDebouncedCallbackOnChange';
import styles from './TimersCreate.module.scss';
import AdvancedRevealButton from '../AdvancedRevealButton';
var DEFAULT_VALUES = {
    name: '',
    message: '',
    interval: '5',
    lines: 2,
    alias: ''
};
var MIN_INTERVAL = 5; // minutes
var MAX_INTERVAL = 60; // minutes
var MIN_LINES = 2;
var MAX_LINES = 100;
function useTimerFormSchema(channelId) {
    var customCommands = useCustomCommandStore(function(state) {
        return state.getCommandsForChannel(channelId);
    });
    var defaultCommands = useDefaultCommandStore(function(state) {
        return state.getCommandsForChannel(channelId);
    });
    useEffect(function() {
        if (channelId == null) {
            return;
        }
        getCustomCommands(channelId);
        getDefaultCommands(channelId);
    }, [
        channelId
    ]);
    return useIntlMemo(function(intl) {
        var filteredCustomCommands = customCommands === null || customCommands === void 0 ? void 0 : customCommands.map(function(command) {
            return command.name;
        });
        var filteredDefaultCommands = defaultCommands === null || defaultCommands === void 0 ? void 0 : defaultCommands.map(function(command) {
            return command.name;
        });
        return Yup.object().shape({
            name: Yup.string().required(intl.formatMessage({
                id: "Gvxoji",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Name is required"
                    }
                ]
            })).min(1, intl.formatMessage({
                id: "sC8N/O",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Name must be at least 1 character long"
                    }
                ]
            })).max(50, intl.formatMessage({
                id: "N2/BvL",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Name must be at most 50 characters long"
                    }
                ]
            })),
            message: Yup.string().required(intl.formatMessage({
                id: "Plg5d3",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Message is required"
                    }
                ]
            })).min(1, intl.formatMessage({
                id: "5kAU82",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Message must be at least 1 character long"
                    }
                ]
            })).max(500, intl.formatMessage({
                id: "E/BnRk",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Message must be at most 500 characters long"
                    }
                ]
            })).when('alias', {
                is: function(alias) {
                    return alias != null && alias.length > 0;
                },
                then: function(schema) {
                    return schema.notRequired().nullable();
                }
            }),
            interval: Yup.number().required(intl.formatMessage({
                id: "d7s2HP",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Interval is required"
                    }
                ]
            })).min(MIN_INTERVAL, intl.formatMessage({
                id: "yIhH4R",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Interval must be at least 5 minutes long"
                    }
                ]
            })).max(MAX_INTERVAL, intl.formatMessage({
                id: "4ttw1Z",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Interval must be at most 60 minutes long"
                    }
                ]
            })),
            lines: Yup.number().required(intl.formatMessage({
                id: "EX+oJ3",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Lines is required"
                    }
                ]
            })).min(MIN_LINES, intl.formatMessage({
                id: "ZjIT3W",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Lines must be at least 2"
                    }
                ]
            })).max(MAX_LINES, intl.formatMessage({
                id: "ZvuHjv",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Lines must be at most 100"
                    }
                ]
            })),
            alias: Yup.string().max(50, intl.formatMessage({
                id: "A6SdPi",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Alias must be at most 50 characters long"
                    }
                ]
            })).oneOf(filteredCustomCommands != null && filteredDefaultCommands != null ? _to_consumable_array(filteredCustomCommands).concat(_to_consumable_array(filteredDefaultCommands)) : [], intl.formatMessage({
                id: "i5Oiu8",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Alias must be set to an existing command"
                    }
                ]
            })).nullable()
        });
    }, [
        customCommands,
        defaultCommands
    ]);
}
export default function Timers(param) {
    var formik = param.formik, title = param.title, submitText = param.submitText, error = param.error;
    var intl = useIntl();
    var _useDisclosure = _sliced_to_array(useDisclosure(), 2), advancedOpen = _useDisclosure[0], advancedHandlers = _useDisclosure[1];
    var back = useBackButton(WebRoutes.TIMERS).back;
    var _formik_values_name, _formik_values_message, _formik_values_interval, _formik_values_lines, _formik_values_alias;
    return /*#__PURE__*/ _jsxs(DashboardLayout, {
        containerProps: {
            maxWidth: 'container.md'
        },
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: title
            }),
            /*#__PURE__*/ _jsx(BackButton, {
                fallbackParams: WebRoutes.TIMERS,
                children: /*#__PURE__*/ _jsx(FormattedMessage, {
                    id: "q5NYii",
                    defaultMessage: "Timers"
                })
            }),
            /*#__PURE__*/ _jsx(Title, {
                size: "sm",
                children: title
            }),
            /*#__PURE__*/ _jsx(TextInput, {
                autoFocus: true,
                "data-1p-ignore": true,
                name: "name",
                label: intl.formatMessage({
                    id: "HAlOn1",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Name"
                        }
                    ]
                }),
                value: (_formik_values_name = formik.values.name) !== null && _formik_values_name !== void 0 ? _formik_values_name : '',
                onBlur: formik.handleBlur,
                onChange: formik.handleChange,
                error: formik.touched.name != null ? formik.errors.name : undefined,
                placeholder: intl.formatMessage({
                    id: "caDyyP",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "My Socials Timer"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Textarea, {
                name: "message",
                label: intl.formatMessage({
                    id: "T7Ry38",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Message"
                        }
                    ]
                }),
                error: formik.touched.message != null ? formik.errors.message : undefined,
                value: (_formik_values_message = formik.values.message) !== null && _formik_values_message !== void 0 ? _formik_values_message : '',
                onBlur: formik.handleBlur,
                onChange: formik.handleChange,
                placeholder: intl.formatMessage({
                    id: "wgZ4Sw",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Find us on X "
                        },
                        {
                            type: 1,
                            value: "X"
                        },
                        {
                            type: 0,
                            value: " & Youtube "
                        },
                        {
                            type: 1,
                            value: "YOUTUBE"
                        },
                        {
                            type: 0,
                            value: " & Twitch "
                        },
                        {
                            type: 1,
                            value: "TWITCH"
                        }
                    ]
                }, {
                    X: ExternalUrls.X,
                    YOUTUBE: ExternalUrls.YOUTUBE,
                    TWITCH: ExternalUrls.TWITCH
                })
            }),
            /*#__PURE__*/ _jsx(NumberInput, {
                name: "interval",
                max: MAX_INTERVAL,
                min: MIN_INTERVAL,
                value: (_formik_values_interval = formik.values.interval) !== null && _formik_values_interval !== void 0 ? _formik_values_interval : '',
                error: formik.touched.interval != null ? formik.errors.interval : undefined,
                onBlur: formik.handleBlur,
                label: intl.formatMessage({
                    id: "aM0Ooj",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Interval (minutes)"
                        }
                    ]
                }),
                onChange: function(value) {
                    return formik.setFieldValue('interval', value);
                }
            }),
            /*#__PURE__*/ _jsx(AdvancedRevealButton, {
                open: advancedOpen,
                onClick: advancedHandlers.toggle
            }),
            advancedOpen || formik.errors.lines !== undefined || formik.errors.alias !== undefined ? /*#__PURE__*/ _jsxs(React.Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(NumberInput, {
                        max: MAX_LINES,
                        min: MIN_LINES,
                        label: intl.formatMessage({
                            id: "T2ZVQY",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Lines"
                                }
                            ]
                        }),
                        error: formik.errors.lines,
                        onBlur: formik.handleBlur,
                        value: (_formik_values_lines = formik.values.lines) !== null && _formik_values_lines !== void 0 ? _formik_values_lines : '',
                        onChange: function(value) {
                            return formik.setFieldValue('lines', value);
                        }
                    }),
                    /*#__PURE__*/ _jsx(TextInput, {
                        name: "alias",
                        value: (_formik_values_alias = formik.values.alias) !== null && _formik_values_alias !== void 0 ? _formik_values_alias : '',
                        onBlur: formik.handleBlur,
                        onChange: formik.handleChange,
                        placeholder: "!commands",
                        description: intl.formatMessage({
                            id: "8oXWNx",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "A command this timer is an alias of. When this timer is triggered, the command listed here will be executed instead."
                                }
                            ]
                        }, {
                            name: formik.values.name
                        }),
                        label: intl.formatMessage({
                            id: "wVPpM1",
                            defaultMessage: [
                                {
                                    type: 0,
                                    value: "Alias Of"
                                }
                            ]
                        }),
                        error: formik.errors.alias
                    })
                ]
            }) : null,
            /*#__PURE__*/ _jsxs("div", {
                className: styles.buttonGroup,
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        size: "xs",
                        onClick: back,
                        children: /*#__PURE__*/ _jsx(FormattedMessage, {
                            id: "47FYwb",
                            defaultMessage: "Cancel"
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "inverse",
                        size: "xs",
                        disabled: !formik.dirty || !formik.isValid,
                        onClick: function() {
                            return formik.handleSubmit();
                        },
                        loading: formik.isSubmitting,
                        children: submitText
                    })
                ]
            }),
            error != null ? /*#__PURE__*/ _jsx(Text, {
                size: "sm",
                className: styles.textError,
                children: error
            }) : null
        ]
    });
}
export function TimersCreate() {
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var navigate = useNavigate();
    var _React_useState = _sliced_to_array(React.useState(null), 2), error = _React_useState[0], setError = _React_useState[1];
    var intl = useIntl();
    var CustomTimerFormSchema = useTimerFormSchema(channel === null || channel === void 0 ? void 0 : channel._id);
    var formik = useFormik({
        initialValues: DEFAULT_VALUES,
        validationSchema: CustomTimerFormSchema,
        validateOnChange: false,
        validateOnMount: true,
        onSubmit: function(values, param) {
            var setSubmitting = param.setSubmitting;
            if (channel == null) {
                return;
            }
            setSubmitting(true);
            createTimer(channel._id, _object_spread_props(_object_spread({}, values), {
                interval: "*/".concat(values.interval, " * * * *")
            })).then(function(newTimer) {
                var url = new URL(WebRoutes.TIMERS, window.location.origin);
                url.searchParams.set('search', newTimer.name);
                navigate(url.pathname + url.search);
            }).catch(function(error) {
                if (_instanceof(error, Error)) {
                    setError(error.message);
                } else {
                    setError('An unknown error occurred.');
                }
                setSubmitting(false);
            });
        }
    });
    useDebouncedCallbackOnChange(formik, formik.validateForm);
    return /*#__PURE__*/ _jsx(Timers, {
        formik: formik,
        error: error,
        title: intl.formatMessage({
            id: "JhBE/L",
            defaultMessage: [
                {
                    type: 0,
                    value: "New Timer"
                }
            ]
        }),
        submitText: intl.formatMessage({
            id: "VzzYJk",
            defaultMessage: [
                {
                    type: 0,
                    value: "Create"
                }
            ]
        })
    });
}
export function TimersEdit() {
    var channel = useChannelStore(function(state) {
        return state.channel;
    });
    var CustomTimerFormSchema = useTimerFormSchema(channel === null || channel === void 0 ? void 0 : channel._id);
    var navigate = useNavigate();
    var intl = useIntl();
    var _React_useState = _sliced_to_array(React.useState(null), 2), error = _React_useState[0], setError = _React_useState[1];
    var timerId = useParams().timerId;
    var back = useBackButton(WebRoutes.TIMERS).back;
    var cachedTimer = useTimerStore(function(state) {
        return channel != null && timerId != null ? state.getTimer(channel._id, timerId) : null;
    });
    var parseTimer = React.useCallback(function(timer) {
        var cron = CronExpressionParser.parse(timer.interval);
        var prev = cron.prev().toDate();
        var next = cron.next().toDate();
        var diffMinutes = Math.abs(next.getTime() - prev.getTime()) / 60e3;
        return _object_spread_props(_object_spread({}, timer), {
            interval: diffMinutes.toString()
        });
    }, []);
    var formik = useFormik({
        initialValues: cachedTimer != null ? parseTimer(cachedTimer) : DEFAULT_VALUES,
        validationSchema: CustomTimerFormSchema,
        validateOnChange: false,
        validateOnMount: true,
        onSubmit: function(values, param) {
            var setSubmitting = param.setSubmitting;
            if (channel == null || timerId == null) {
                return;
            }
            setSubmitting(true);
            updateTimer(channel._id, _object_spread_props(_object_spread({
                _id: timerId
            }, values), {
                interval: "*/".concat(values.interval, " * * * *")
            })).then(function() {
                return back();
            }).catch(function(error) {
                if (_instanceof(error, Error)) {
                    setError(error.message);
                } else {
                    setError('An unknown error occurred.');
                }
                setSubmitting(false);
            });
        }
    });
    useDebouncedCallbackOnChange(formik, formik.validateForm);
    React.useEffect(function() {
        if (channel == null) {
            return;
        }
        if (timerId == null) {
            navigate(WebRoutes.TIMERS);
            return;
        }
        getTimer(channel._id, timerId).then(function(timer) {
            return formik.resetForm({
                values: parseTimer(timer)
            });
        }).catch(function() {
            return navigate(WebRoutes.TIMERS);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        timerId,
        channel,
        navigate
    ]);
    return /*#__PURE__*/ _jsx(Timers, {
        formik: formik,
        error: error,
        title: intl.formatMessage({
            id: "gs33Q2",
            defaultMessage: [
                {
                    type: 0,
                    value: "Edit Timer"
                }
            ]
        }),
        submitText: intl.formatMessage({
            id: "BWpuKl",
            defaultMessage: [
                {
                    type: 0,
                    value: "Update"
                }
            ]
        })
    });
}
